/*
 * Puts the theme's social + legal footer into Rivo's account slideout.
 *
 * Rivo offers no setting for it, so the block is authored in
 * snippets/rivo-account-footer.liquid and cloned in here once the slideout
 * exists. Everything below is defensive on purpose: if Rivo is not on the
 * page, or its markup changes, nothing happens and nothing breaks.
 */
(function () {
  var TEMPLATE_ID = 'rivo-account-footer';
  var MARKER = '[data-nom-account-footer]';

  /* The home tab's scroll container. The block goes inside it rather than
     beside it so it hides along with the tab when the shopper switches to
     Orders or Profile. */
  var HOME_PAGE = '.rivo-slideout__content .rivo-home-page';

  function insert() {
    var page = document.querySelector(HOME_PAGE);
    if (!page || page.querySelector(MARKER)) return;

    var template = document.getElementById(TEMPLATE_ID);
    if (!template || !template.content) return;

    page.appendChild(template.content.cloneNode(true));
  }

  function start() {
    insert();

    var content = document.querySelector('.rivo-slideout__content');
    if (!content) return;

    /*
     * Rivo re-renders the home tab on every navigation, which drops the block.
     * Re-inserting on mutation is safe against a loop: the append itself fires
     * the observer, and the next pass finds the marker and returns.
     */
    new MutationObserver(insert).observe(content, { childList: true, subtree: true });
  }

  /* Rivo fires this once ba_rivo_profile.js has built the slideout. The
     interval is the fallback for the case where the event has already gone
     off before this script parsed. */
  document.addEventListener('rivo-accounts:loaded', start);

  var tries = 0;
  var poll = window.setInterval(function () {
    tries += 1;
    if (document.querySelector('.rivo-slideout__content')) {
      window.clearInterval(poll);
      start();
      return;
    }
    /* ~10s. Past that Rivo is not on this page and there is nothing to wait for. */
    if (tries > 40) window.clearInterval(poll);
  }, 250);
})();
